<template>
  <div v-if="permissions">
    <weekly-menu
      v-if="contentTypeData && contentTypeData.Type === 'weeklyMenu'"
      :contentTypeData="contentTypeData"
    />
    <event
      v-else-if="contentTypeData && contentTypeData.Type === 'event'"
      :key="contentTypeID"
      :contentTypeID="contentTypeID"
      :workspaceID="contentTypeData.WorkspaceID"
      :locale="locale"
    />
    <activity-barcelo
      v-else-if="contentTypeData && contentTypeData.Type === 'activityBarcelo'"
      :contentTypeDataID="contentTypeID"
      :contentTypeData="contentTypeData ? JSON.parse(contentTypeData.ActivityBarceloConfig) : null"
      :workspaceID="contentTypeData.WorkspaceID"
      :locale="locale"
    />
    <!--meeting-room
      v-else-if="contentTypeData && contentTypeData.Type === 'meetingRoom'"
      :contentTypeData="contentTypeData"
    /-->
    <v-layout wrap v-else-if="contentTypeData">
      <v-flex xs8 
        style="padding:20px 10px 20px 20px;height:calc(100vh - 65px);overflow-y: auto;overflow-x: hidden;scrollbar-width: none !important;"
      >
        <v-card elevation="0">
          <v-card-text style="padding:0px;">
            <list-content
              v-if="headers && contentTypeData"
              :id="contentTypeData.ID" 
              :onSearch="handleSearch"
              :onEditItem="handleEditItem"
              :onCloneItem="handleCloneItem"
              :onDeleteItem="handleDeleteItem"
              :onSort="handleSort"
              :icon="contentTypeData.icon"
              :title="contentTypeData.Name"
              :headers="headers"
              :data="data"
              :loading="loading"
              :locale="locale"
              :type="typeList"
              :contentTypeData="contentTypeData"
              :itemsPerPage="itemsPerPage"
              :totalDuration="totalDuration"
              :onChangeVisibilityFilter="['media', 'message', 'audio', 'htmlToImage'].indexOf(contentTypeData.Type) >= 0 ? handleChangeVisibilityFilter : null"
              :playLoopConfig="playLoopConfig"
              :prevHeight="80 * contentTypeData.Height / contentTypeData.Width"
              :onChangeMultiSelect="['media', 'message', 'audio', 'htmlToImage'].indexOf(contentTypeData.Type) >= 0 ? handleChangeMultiSelect : null"

              :clearMultiSelect="clearMultiSelect"
              :onShareContent="shareContentConfig ? handleShareContentForm : null"
              :onShowQRDynamic="handleShowQRDynamic"
            />
            <pagination
              :count="count"
              :onGetData="handleGetData"
              :startIndex="startIndex"
              :itemsPerPage="itemsPerPage"
              :locale="locale"
              :onChangeItemsPerPage="handleChangeItemsPerPage"

              :multiSelectedID="multiSelectedID"
              :onDeleteItem="handleDeleteMultiID"
              :onHideItem="handleHideMultiID"
              :onShowItem="handleShowMultiID"
            />
          </v-card-text>
        </v-card>
        <!--availability-legend :locale="locale" /-->
      </v-flex>
      <v-flex xs4 style="padding:20px 20px 20px 10px;"
      >
        <v-card
          style="height:calc(100vh - 104px);overflow-y: auto;overflow-x: hidden;scrollbar-width: thin !important;"
          elevation="0"
        >
          <v-card-text>
            <v-btn
              v-if="!showForm && !shareContentEditedID"
              @click="handleAddContent"
              color="primary"
              block
              dark
            >
              {{ $t('common.add', locale) }}
            </v-btn>
            <availability-legend 
              v-if="!showForm && !shareContentEditedID && contentTypeData.Type !== 'qrDynamic'"
              :isVertical="true"
              :locale="locale" 
            />

            <share-content-form
              v-if="shareContentEditedID"
              :shareContentConfig="shareContentConfig"
              :editedID="shareContentEditedID"
              :onClose="handleCloseShareContentForm"
              :contentType="contentTypeData.Type"
              :contentTypeID="contentTypeData.ID"
            />
            <message-form
              v-if="contentTypeData.Type === 'message' && showForm"
              :isClone="isClone"
              :editedID="editedID"
              :contentTypeDataID="contentTypeData.ID"
              :title="contentTypeData.Name"
              :icon="contentTypeData.icon"
              :onClose="handleCloseForm"
              :onDelete="handleDeleteItem"
            />
            <media-form
              v-else-if="contentTypeData.Type === 'media' && showForm"
              :isClone="isClone"
              :editedID="editedID"
              :contentTypeData="contentTypeData"
              :allowedTypes="contentTypeData.AllowedTypes"
              :title="contentTypeData.Name"
              :icon="contentTypeData.icon"
              :onClose="handleCloseForm"
              :onDelete="handleDeleteItem"
            />
            <audio-form
              v-else-if="contentTypeData.Type === 'audio' && showForm"
              :editedID="editedID"
              :contentTypeData="contentTypeData"
              :title="contentTypeData.Name"
              :icon="contentTypeData.icon"
              :onClose="handleCloseForm"
              :onDelete="handleDeleteItem"
            />
            <meeting-room-form
              v-else-if="contentTypeData.Type === 'meetingRoom' && showForm"
              :editedID="editedID"
              :contentTypeData="contentTypeData"
              :contentTypeDataID="contentTypeData.ID"
              :title="contentTypeData.Name"
              :icon="contentTypeData.icon"
              :onClose="handleCloseForm"
              :onDelete="handleDeleteItem"
            />
            <html-to-image-form
              v-if="contentTypeData.Type === 'htmlToImage' && showForm"
              :editedID="editedID"
              :contentTypeDataID="contentTypeData.ID"
              :title="contentTypeData.Name"
              :icon="contentTypeData.icon"
              :onClose="handleCloseForm"
              :onDelete="handleDeleteItem"
            />
            <qr-dynamic-form
              v-if="contentTypeData.Type === 'qrDynamic' && showForm"
              :isClone="isClone"
              :editedID="editedID"
              :contentTypeDataID="contentTypeData.ID"
              :title="contentTypeData.Name"
              :icon="contentTypeData.icon"
              :onClose="handleCloseForm"
              :onDelete="handleDeleteItem"
            />
            <!--file-form
              v-else-if="showFileForm" 
              :data="editedItem"
              :onClose="handleCloseForms"
              :onDelete="handleDeleteItem"
            /-->
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
        <div class="text-center">
          <v-dialog
            v-model="showQR"
            width="500"
          >
            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                Privacy Policy
              </v-card-title>

              <v-card-text>
                <v-card
                  style="text-align: center;padding: 50px 0;"
                >
                  <v-img
                    v-show="false"
                    v-if="qrImage && qrImage.length > 0"
                    :src="qrImage"
                    :lazy-src="qrImage"
                    aspect-ratio="1"
                    class="grey lighten-2"
                    width="100%"
                    height="auto"
                  />
                  <div v-if="svg" v-html="svg" />
                  <br/>
                  <br/>
                  <a v-if="selectedQR" :href="`https://widgets.dviewcontent.com/qrdynamic/index.php?ID=${selectedQR.ID}`">https://widgets.dviewcontent.com/qrdynamic/?ID={{selectedQR.ID}}</a>
                  <br/>
                  <v-icon color="primary">mdi-download</v-icon>
                  <a href="#" @click="downloadSVG" class="link-download btn btn-primary btn-sm" style="text-decoration: none;">{{ $t('share.downloadSVG', locale).toUpperCase() }}</a>
                </v-card>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  text
                  @click="handleShowQRDynamic(null)"
                >
                  Salir
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
  </div>
</template>
<script>
  const router = {
    message: 'messages',
    qrDynamic: 'qr-dynamic',
    htmlToImage: 'html-to-images',
    media: 'media',
    audio: 'audios',
    meetingRoom: 'meeting-room',
  }
  const headers = {
    qrDynamic: [
      { text: 'content.name', value: 'Name',  sortable: false, },
      { text: 'content.type', value: 'Type',  sortable: false, },
      { text: 'content.access', value: 'Access',  sortable: false, },
      { text: '', value: 'QR',  sortable: false, },
    ],
    message: [
      { text: '', sortable: false, },
      { text: '', sortable: false, },
      { text: '', sortable: false, },
      { text: 'content.name', value: 'Name',  sortable: false, },
      { text: 'content.message', value: 'Message',  sortable: false, },
      { text: '', sortable: false, },
      { text: 'content.schedule',  sortable: false },
      { text: '',  sortable: false },
    ],
    media: [
      { text: '', sortable: false, },
      { text: '', sortable: false, },
      { text: '', sortable: false, },
      { text: 'content.media', value: 'MediaURL',  sortable: false, align: 'center', },
      { text: 'content.name', value: 'Name',  sortable: false, },
      { text: 'content.time', value: 'Time',  sortable: false, align: 'center', },
      { text: '', sortable: false, },
      { text: 'content.schedule',  sortable: false },
      { text: '',  sortable: false },
    ],
    audio: [
      { text: '', sortable: false, },
      { text: '', sortable: false, },
      { text: 'content.name', value: 'Name',  sortable: false, },
      { text: 'content.sequence', value: 'Sequence',  sortable: false, align: 'center', },
      { text: 'content.schedule',  sortable: false },
      { text: '',  sortable: false },
    ],
    meetingRoom: [
      { text: '', sortable: false, },
      { text: 'content.media', value: 'MediaURL',  sortable: false, align: 'center', },
      { text: 'content.name', value: 'Name',  sortable: false, },
      { text: 'content.time', value: 'Time',  sortable: false, align: 'center', },
      { text: 'content.schedule',  sortable: false },
      { text: '',  sortable: false },
    ],
    htmlToImage: [
      { text: '', sortable: false, },
      { text: '', sortable: false, },
      { text: 'content.name', value: 'Name',  sortable: false, },
      { text: 'content.url', value: 'URL',  sortable: false, },
      { text: 'content.time', value: 'Time',  sortable: false, align: 'center', },
      { text: 'content.schedule',  sortable: false },
      { text: '',  sortable: false },
    ],
  }

  import { mapState } from 'vuex'
  import QRCode from 'qrcode'
  import api from '@/services/api'
  import utilsService from '@/services/utils'
  import Pagination from '@/components/customTable/Pagination'
  import ListContent from './listContent/Index'
  import AvailabilityLegend from './listContent/AvailabilityLegend'
  import ShareContentForm from './ShareContentForm'
  import MessageForm from './MessageForm'
  import MediaForm from './mediaForm/Index'
  import AudioForm from './AudioForm'
  import WeeklyMenu from './weeklyMenu/Index'
  import ActivityBarcelo from './activityBarcelo/Index'
  import Event from './event/Index'
  import MeetingRoomForm from './meetingRoom/Index'
  import HtmlToImageForm from './HtmlToImageForm'
  import QrDynamicForm from './QrDynamicForm'
  export default{
    components: {
      ListContent,
      ShareContentForm,
      MessageForm,
      MediaForm,
      AudioForm,
      Pagination,
      WeeklyMenu,
      ActivityBarcelo,
      MeetingRoomForm,
      AvailabilityLegend,
      HtmlToImageForm,
      Event,
      QrDynamicForm,
    },
    data() {
      return {
        loading: false,
        headers: null,
        contentTypeData: null,
        isClone: false,
        editedID: null,
        showForm: false,
        search: '',
        startIndex: 0,
        itemsPerPage: 10,
        data: [],
        count: null,
        typeList: null,
        totalDuration: null,
        visibilityFilter: [0],

        multiSelectedID: [],

        shareContentConfig: null,
        shareContentEditedID: null,

        permissions: null,
        selectedQR: null,
        showQR: false,
        qrImage: null,
        svg: null,
      }
    },
    computed: {
      ...mapState('app',['locale', 'dviewcontentWorkspace']),
      workspaceID () {
        return this.dviewcontentWorkspace
      },
      userID () {
        return utilsService.getUser()
      },
      contentTypeID () {
        return this.$route.params.id
      },
      pathVersion () {
        return ['meetingRoom', 'htmlToImage'].indexOf(this.contentTypeData.Type) >= 0 ? 'v1/' : ''
      },
      baseAPIURL () {
        return process.env.VUE_APP_ENV === 'development' ? 'http://localhost:3900' : 'https://cm-dviewcontent-api.dviewcontent.com'
      },
      playLoopConfig () {
        if (this.contentTypeData.Type !== 'media') return
        return {
          width: this.contentTypeData.Width,
          height: this.contentTypeData.Height,
          //url: 'https://cm-dviewcontent-api.dviewcontent.com/assets/6bc3d12d-b5a3-43a1-bada-58cb1fad8b09/ac181b77-bf19-4a60-ab8e-b2c28d2b1d05/rss.xml',
          url: `${this.baseAPIURL}/assets/${this.contentTypeData.WorkspaceID}/${this.contentTypeData.ID}/rss.xml`.concat(`?t=${new Date().toISOString()}`),
        }
      },
    },
    watch: {
      '$route.params.id'() {
        this.visibilityFilter = [0]
        this.handleGetContentType()
      }
    },
    mounted() {
      this.handlePrepareMF()
      this.handleGetContentType()
    },
    methods: {
      handlePrepareMF () {
        api.getAll('dviewcontent', `public/cron/${this.contentTypeID}`, 0, 100, '')
      },
      handleGetTotalDuration () {
        if (!this.contentTypeID) {
          this.totalDuration = null
          return
        }
        if (['message', 'audio' ,'meetingRoom', 'qrDynamic'].indexOf(this.contentTypeData.Type) >= 0) {
          this.totalDuration = null
          return
        }
        api.put('dviewcontent', `${this.pathVersion}private/${router[this.contentTypeData.Type]}/${this.contentTypeID}/total-duration`, this.startIndex, this.itemsPerPage, this.search)
          .then(response => {
            this.totalDuration = response && response.data !== null ? response.data : null
          })
      },
      async handleCheckPermissions (callback) {
        try {
          const result = await new Promise((resolve) => api.getAll('dviewcontent', `v1/internal/workspaces/${this.workspaceID}/content-types/${this.contentTypeID}/users/${this.userID}/permissions`, 0, 100, '')
            .then(response => {
              resolve(response)
            }))
          return callback(null, result)
        } catch (error) {
          console.log(error)
          return callback(error)
        }
      },
      async handleGetContentType () {
        try {
          this.permissions = null
          this.permissions = await new Promise((resolve, reject) => this.handleCheckPermissions((err, rows) => {
            if (err) reject(err)
            else resolve(rows)
          }))
          this.showForm = false
          this.loading = true
          this.shareContentConfig = null // used to share content with another workspaces
          let contentTypeData = await new Promise((resolve) => api.getItem ('dviewcontent', 'private/content-types/', this.contentTypeID)
            .then(response => {
              response.AllowedTypes = !response.AllowedTypes ? null : response.AllowedTypes.map(item => {
                let value = item
                let name = item
                if (value.length === 36) {
                  name = response.CustomContentTypes ? response.CustomContentTypes.filter(x => x.ID === name).map(item => item.Name).shift() : value
                }
                return {
                  name,
                  value,
                }
              })
              resolve(response)
            }))
          this.contentTypeData = contentTypeData

          this.typeList=router[this.contentTypeData.Type]
          if (headers[this.contentTypeData.Type]) {
            let headersFormated = headers[this.contentTypeData.Type]
            if (['media', 'message'].indexOf(this.contentTypeData.Type)>= 0) {
              // if media/message check shareContent config
              this.shareContentConfig = await new Promise((resolve) => api.getAllWithoutLimit ('dviewcontent', `private/content-types/${this.contentTypeID}/share-content-config`)
                .then(response => {
                  resolve(response && response.length > 0 ? response : null)
                }))
            }
            if (this.contentTypeData.Type === 'audio' && !this.contentTypeData.BySequence) {
              headersFormated = headersFormated.filter(x => x.value != 'Sequence')
            }
            headersFormated = headersFormated.map(item => {
              if(item.text && item.text.indexOf('.') > 0) item.text = this.$t(item.text, this.locale)
              return item
            })
            /*
            if (this.shareContentConfig) {
              headersFormated.splice(2, 0, { text: '', value: 'Name',  sortable: false, })
            }*/
            this.headers = headersFormated
            this.handleGetData()
          } else {
            this.startIndex = 0
            this.count = 0
            this.headers = []
            this.data = []
          }
        } catch (error) {
          console.log(error)
        }
      },
      handleGetData (startIndex) {
        this.loading = true
        this.clearMultiSelect = new Date().toISOString()
        if (startIndex >= 0 ) this.startIndex = startIndex
        const url = `${this.pathVersion}private/${router[this.contentTypeData.Type]}/${this.contentTypeID}/`
        api.getAll ('dviewcontent', url, this.startIndex, this.itemsPerPage, this.search, this.visibilityFilter.join(','))
          .then(response => {
            if (response) {
              this.count = response.count
              this.data = response.data.map (item => {
                if (this.contentTypeData.Type === 'media') {
                  item.previewConfig = {
                    width: this.contentTypeData.Width,
                    height: this.contentTypeData.Height,
                    screenshot: item.Screenshot,
                    url: item.MediaURL,
                    type: item.Type,
                  }
                }
                return item
              })
            }
            this.loading = false
            this.handleGetTotalDuration()
          })
      },
      handleEditItem (id) {
        this.isClone = false
        this.editedID = id
        this.showForm = true
      },
      handleCloneItem (v) {
        this.isClone = true
        this.editedID = v
        this.showForm = true
      },
      handleDeleteItem (id) {
        api.deleteItem ('dviewcontent', `${this.pathVersion}private/${router[this.contentTypeData.Type]}/${this.contentTypeData.ID}/`, id)
          .then(() => {   
            this.handleCloseForm()
          })
      },
      handleAddContent () {
        this.isClone = false
        this.editedID = null
        this.showForm = true
      },
      handleGenerateMediaFeed () {
        api.getAll('dviewcontent', `private/cron/${this.contentTypeData.ID}`)
          .then(() => {
            this.$store.state.app.mainAlert = {
              type: 'info',
              icon: 'mdi-information',
              message: this.$t(`content.messages.generateMediaFeed`, this.locale),
            }
          })
      },
      handleSearch (v) {
        this.search = v
        this.handleGetData()
      },
      handleCloseForm () {
        this.isClone = false
        this.handlePrepareMF()
        this.handleGetData()
        this.showForm = false
      },
      handleSort(v) {
        const body = []
        const maxValue = Math.max.apply(null, v.map((o) => { return o.ORD }))
        for (let i = 0; i < v.length; i++)
          body.push ({ ID: v[i].ID, ORD: maxValue - i})
         
        api.put ('dviewcontent', `${this.pathVersion}private/${router[this.contentTypeData.Type]}/${this.contentTypeData.ID}/sort`, body)          
      },
      handleChangeItemsPerPage (v) {
        if (v) {
          this.startIndex = 0
          this.itemsPerPage = v
          this.handleGetData()
        }
      },
      handleChangeVisibilityFilter (v) {
        this.visibilityFilter = v
        this.handleGetData()
      },
      handleChangeMultiSelect (v) {
        this.multiSelectedID = v
      },
      handleDeleteMultiID (v) {
        api.deleteItem ('dviewcontent', `${this.pathVersion}private/${router[this.contentTypeData.Type]}/${this.contentTypeData.ID}/`, v.concat('/multi'))
          .then(() => {   
            this.handlePrepareMF()
            this.handleGetData()
          })
      },
      handleHideMultiID () {
        const body = {
          IDs: this.multiSelectedID
        }
        api.put ('dviewcontent', `${this.pathVersion}private/${router[this.contentTypeData.Type]}/${this.contentTypeData.ID}/multi-hide`, body)    
          .then (() => {
            this.handlePrepareMF()
            this.handleGetData()
          })
      },
      handleShowMultiID () {
        const body = {
          IDs: this.multiSelectedID
        }
        api.put ('dviewcontent', `${this.pathVersion}private/${router[this.contentTypeData.Type]}/${this.contentTypeData.ID}/multi-show`, body)    
          .then (() => {
            this.handlePrepareMF()
            this.handleGetData()
          })
      },
      handleShareContentForm (v) {
        this.shareContentEditedID = v.ID
      },
      handleCloseShareContentForm () {
        this.shareContentEditedID = null
      },
      handleShowQRDynamic (v) {
        this.selectedQR = v
        this.showQR = v ? true : false
        QRCode.toDataURL(`https://widgets.dviewcontent.com/qrdynamic/?ID=${v.ID}`, {
          type: 'image/png',
          width: 344,
          color: {
            dark: '#000000',  // Blue dots
            light: '#FFFFFF'
          }
        })
        .then(url => {
          this.qrImage = url
        })
        .catch(err => {
          console.error(err)
        })

        QRCode.toString(`https://widgets.dviewcontent.com/qrdynamic/?ID=${v.ID}`, {
          type: 'image/svg',
          color: {
            dark: '#000',
            light: 'red'
          }
        })
        .then(url => {
          this.svg = url.replace('<svg', '<svg id="dynamicIllustration" ')
        })
        .catch(err => {
          console.error(err)
        })
      },
      downloadSVG (evt) {
        const svgContent = document.getElementById("dynamicIllustration").outerHTML,
          blob = new Blob([svgContent], {
            type: "image/svg+xml"
          }),
          url = window.URL.createObjectURL(blob),
          link = evt.target;

        link.target = "_blank"
        link.download = `qr_${this.selectedQR.Name}.svg`
        link.href = url
      },
    }
  }
</script>

<style>
  ::-webkit-scrollbar {
    display: none;
  }
</style>
